import { PageHeader } from '@app/components/layout/page/components/page-header';
import Page from '@app/components/layout/page/page';
import { soldGoodsRoutes } from '@app/sold-goods/sold-goods-routes';
import { Icons } from '@shared/components/content/icons';
import { PageTabs } from '@shared/components/page-tabs';
import { Button } from '@shared/components/ui/button';
import { useHistory } from '@shared/providers/history-provider';
import { useState } from 'react';
import { generatePath, Outlet, useNavigate } from 'react-router-dom';
import { getFoodReferrerLabel } from '../utils';
import { useSoldFoodAndDrinkTabs } from './tabs';

export default function SoldFoodAndDrinkLayout() {
  const navigate = useNavigate();
  const tabs = useSoldFoodAndDrinkTabs();
  const history = useHistory();
  const [referrer] = useState<string | undefined>(history.previousLocation);
  return (
    <Page name="Food and drink" title="Sold Food and Drink">
      <PageHeader
        name="Food and drink"
        tabs={<PageTabs tabs={tabs} />}
        breadcrumbs={[
          {
            label: 'Sold goods',
            url: generatePath(soldGoodsRoutes.SOLD_FOOD_AND_DRINK),
          },
          {
            label: 'Food and drink',
            url: generatePath(soldGoodsRoutes.SOLD_FOOD_AND_DRINK, {
              category: generatePath(soldGoodsRoutes.SOLD_FOOD_AND_DRINK),
            }),
          },
        ]}
        toolbar={
          referrer &&
          (referrer.startsWith('/sold-goods/reports/') ||
            referrer.startsWith('/company-reports/')) ? (
            <Button
              variant="ghost"
              onClick={() => navigate(referrer)}
              icon={<Icons.chevronLeft className="size-4" />}
            >
              {getFoodReferrerLabel(referrer)}
            </Button>
          ) : undefined
        }
      />
      <Outlet />
    </Page>
  );
}
